module.exports = __webpack_public_path__ + "static/media/journal_doodle.68e13e61.svg";